import extend from '@/utils/vuex-extend';
import {table} from '@/vuex-extend';
import {wait} from '@/utils/wait';
import moment from 'moment';
import {getAllAdminList} from "@/api/sms/arrival-order";
import {getStockedSkuList, getTotalInfo, purchasedExport, stockedExport, stockedTotal} from "@/api/scm/purchase-report";

const today = moment().format('L')
const generateOptions = (searchForm)=>{
	const params = {}
	if (searchForm.value) {
		params[searchForm.select] = searchForm.value
	}
	if (searchForm.timeSelect === 'stockedTime') {
		params.startTime = new Date(searchForm.time[0]).getTime() / 1000
		params.endTime = new Date(searchForm.time[1]).getTime() / 1000
	}else{
		params.deliveredStartTime = new Date(searchForm.time[0]).getTime() / 1000
		params.deliveredEndTime = new Date(searchForm.time[1]).getTime() / 1000
	}
	return params
}
export default extend(table, {
	namespaced: true,
	state: {
		adminList: [],
		totalInfo: {},
		searchForm: {
			timeSelect: 'stockedTime',
			time: [`${today} 00:00:00`, `${today} 23:59:59`]
		}
	},
	actions: {
		async getList({state, dispatch}, payload) {
			await wait(dispatch, 'scm.stocked-detail.list', async function () {
				const {searchForm} = state;
				const params = generateOptions(searchForm)
				await dispatch('getData', {
					caller: getStockedSkuList,
					options: {
						...params,
						adminUserId: searchForm.adminUserId,
						...payload
					}
				})
			})
		},
		async getAllAdminList({dispatch, commit}) {
			await wait(dispatch, 'scm.stocked-detail.list', async function () {
				let response = await getAllAdminList();
				if (response.data) {
					commit('save', {
						adminList: response.data.adminList
					})
				}
			})
		},
		async getTotalInfo({dispatch, commit, state}) {
			await wait(dispatch, 'scm.stocked-detail.list', async function () {
				const {searchForm} = state;
				const params = generateOptions(searchForm)
				let response = await stockedTotal({
					...params,
					adminUserId: searchForm.adminUserId
				});
				if (response.data) {
					commit('save', {
						totalInfo: response.data
					})
				}
			})
		},
		async purchasedExport({dispatch, state}) {
			await wait(dispatch, 'scm.stocked-detail.list', async function () {
				const {searchForm} = state;
				const params = generateOptions(searchForm)
				await stockedExport({
					...params,
					adminUserId: searchForm.adminUserId
				});
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/scm/stocked-detail/list.js